import * as Yup from "yup"
import _ from "lodash"

// Validators
import validation_default from "./validation_default"
import validation_text from "./validation_text"
import validation_number from "./validation_number"
import validation_dropdown from "./validation_dropdown"

export default function validation_multi_field(field, acc) {
  const { field_name, multi_fields, field_validation } = field

  const isRequired = field_validation?.required[0] === "true"

  if (!isRequired) return acc

  const handleNestedMF = (nested_multi_fields) =>
    _.reduce(
      nested_multi_fields,
      (acc, nmf) => {
        const isMfRequired = nmf.field_validation?.required?.[0] === "true"
        if (!isMfRequired) return acc
        switch (nmf.field_type) {
          case "text":
            return validation_text(field, acc)
          case "number":
            return validation_number(field, acc)
          case "dropdown":
            return validation_dropdown(field, acc)
          default:
            return validation_default(field, acc)
        }
      },
      {}
    )

  const handleMultiField = _.reduce(
    multi_fields,
    (acc, field) => {
      const isMfRequired = field.field_validation?.required?.[0] === "true"
      if (!isMfRequired) return acc

      if (field.field_type === "multi_field_nested") {
        return {
          ...acc,
          [field.field_name]: Yup.array().of(
            Yup.object().shape(handleNestedMF(field.multi_fields))
          ),
        }
      }

      switch (field.field_type) {
        case "text":
          return validation_text(field, acc)
        case "number":
          return validation_number(field, acc)
        case "dropdown":
          return validation_dropdown(field, acc)
        default:
          return validation_default(field, acc)
      }
    },
    {}
  )

  return {
    [field_name]: Yup.array()
      .of(Yup.object().shape(handleMultiField))
      .required("Multi Field is required"),
    ...acc,
  }
}
